<div class="flex">
    <div class="border-r-2 border-neutral-500 pr-3 border-opacity-50">
        <div class="w-max">

        <slot name="icon" />
        </div>
    </div>
    <div class="pl-3">
        <slot />
    </div>
</div>
